import { formatearError } from "../utils/apiUtils";
import { obtenerDatosSocio } from "./socioPrincipal";
import { Socio } from "../models/socioPrincipal.model";
import { ApiError } from "../interfaces/api.error.interface";
import { AsistenciaMedicaActionType } from "../interfaces/global-state/asistencia.medica.action.type.enum";
import { getTextosEditables, loadCanales, loadDeshabilitarModulosPorVersiones, loadServicios } from "../contexts/actions/actions";

/**
 * Metodo que reintenta todas las solicitudes iniciales necesarias para el funcionamiento de asistencia medica
 */
export const reintentarSolicitudesInicio = (user, isWeb, apiRequest, dispatchAsistenciaMedica, storageManager) => {
    return new Promise<Socio>(async (resolve, reject) => {
        let obtenerSocio = {};
        try {
            obtenerSocio = await obtenerDatosSocio( Number(user.userInfo.interlocutorComercial), apiRequest, user)
            dispatchAsistenciaMedica({
                type: AsistenciaMedicaActionType.actualizarUsuario, 
                socio: obtenerSocio
            });
        } catch(error: any) {
            let errorAlInicializar: ApiError = formatearError(error);
            reject(errorAlInicializar)
        }

        try {
            await Promise.all([
                getTextosEditables(dispatchAsistenciaMedica, apiRequest),
                loadDeshabilitarModulosPorVersiones(isWeb, apiRequest, dispatchAsistenciaMedica),
                loadCanales( apiRequest, dispatchAsistenciaMedica, storageManager),
                loadServicios(apiRequest, storageManager, dispatchAsistenciaMedica)
            ])
            resolve(obtenerSocio);
        } catch(error: any) {
            console.error( "ASIS-MED - Ocurrio un error al inicializar los listados globales de Provincias, Factores y Sintomas.", error );
            let errorAlInicializar = formatearError(error);
            reject(errorAlInicializar)
        }
    })
}
